<template>
  <div v-if="link.addSessionId">
    <ExerciseSelectionDialog :dialog="!exercise" mode="add" @update:dialog="closeSelection" @add-selected="configure($event.newExercise)" />
    <v-dialog :value="!!exercise" fullscreen hide-overlay persistent transition="dialog-bottom-transition">
      <v-card dark class="handoff-config">
        <v-toolbar flat color="transparent">
          <v-btn icon :disabled="sending" aria-label="Auswahl schliessen" @click="cancel"><v-icon>mdi-close</v-icon></v-btn>
          <v-toolbar-title>Übung hinzufügen</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <p class="grey--text text--lighten-1">Für dein laufendes Training · {{ title }}</p>
          <v-alert v-if="error" type="error" text>{{ error }}</v-alert>
          <v-progress-linear v-if="sending" indeterminate color="success" class="mb-4" />
          <p v-if="sending" role="status">Wird mit der Uhr abgeglichen …</p>
          <div :class="{ 'handoff-busy': sending }" :inert="sending ? '' : null" :aria-busy="String(sending)">
            <WorkoutSplitEditExerciseSingle v-if="exercise" :exercise-prop="exercise" @savedExercise="save" @cancel-edit="cancel" />
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import linkService from "@/services/watchWorkoutLink"
import ExerciseSelectionDialog from "@/views/workouts/v2/runWorkout/runWorkoutExerciseSelectionDialog.vue"
import WorkoutSplitEditExerciseSingle from "@/views/workouts/WorkoutSplitEditExerciseSingle.vue"

export default {
  components: { ExerciseSelectionDialog, WorkoutSplitEditExerciseSingle },
  data: () => ({ link: linkService.view, exercise: null, sending: false, error: null }),
  computed: {
    title() { return this.link.state?.clientSessionId === this.link.addSessionId ? this.link.state.title : this.$store.state.runWorkoutStore.activeSplit?.title || "Training" },
  },
  watch: { "link.addSessionId"() { this.exercise = null; this.error = null } },
  methods: {
    configure(exercise) { this.exercise = JSON.parse(JSON.stringify(exercise)); this.error = null },
    closeSelection(open) { if (!open && !this.exercise) this.cancel() },
    cancel() { if (!this.sending) linkService.cancelAdd() },
    async save(exercise) {
      if (this.sending) return
      this.sending = true; this.error = null
      try { await linkService.addExercise(exercise); this.$toast?.success("Übung zum laufenden Training hinzugefügt") }
      catch (error) { this.error = error.message }
      finally { this.sending = false }
    },
  },
}
</script>

<style scoped>
.handoff-config { background: #121212; min-height: 100%; }
.handoff-busy { pointer-events: none; opacity: .6; }
</style>
